export const formatDateParams = (searchParams : URLSearchParams) => {
  if (searchParams.has('mes') && searchParams.has('anio')) {
    return `Período ${addZeroToMonth(searchParams.get('mes'))}/${searchParams.get('anio')}`
  }
  return 'Período actual';
}

const addZeroToMonth = (month) => {
  return String(month).padStart(2, '0');
}